import React from "react";
import { LineGL } from "../LineGL";
import { DashLineGL } from "../DashLineGL/index";
import { LineStyle } from "../interfaces/element";
const webGlDomain = [-1, 1];
export const Vertical = (props) => {
    const { x, xMapper } = props;
    const getLineXY = React.useCallback((x, xMapper) => {
        return [xMapper(x), -1, xMapper(x), 1];
    }, []);
    const xy = React.useMemo(() => getLineXY(props.x, xMapper), [x, xMapper]);
    return props.style === LineStyle.solid ? (React.createElement(LineGL, Object.assign({}, props, { domainY: webGlDomain, xy: xy }))) : (React.createElement(DashLineGL, Object.assign({}, props, { domainY: webGlDomain, xy: xy })));
};
//# sourceMappingURL=Vertical.js.map